"use strict";

var AccountFormHelper = require("../accountComponents/AccountFormHelper");
var BillingAddressHelper = require("../accountComponents/BillingAddressHelper");

var AccountApi = require("../api/AccountApi");

var PaymentHelper = require("../commonComponents/PaymentHelper");

var ApiHelper = require("../shared/ApiHelper");
var HtmlHelper = require("../shared/HtmlHelper");
var PartialResponseHelper = require("../shared/PartialResponseHelper");
var SmartyStreets = require("./SmartyStreets");

var MySubscriptionsRefresh = {
	getMySubscriptionsHtml: function (event, subscriptionType, isEditing, accountData, submitAction) {
		var deferred = new $.Deferred();

		var $currentSubscription = $(event.target).closest(this.getSinglePopulatedSelector(subscriptionType));

		var mySubscriptionId = $currentSubscription.attr("data-subscription-id");
		var mySubscriptionComponentId = $currentSubscription.closest(this.getSubscriptionSelector(subscriptionType)).attr("id");

		AccountApi.mySubscriptionsGetSubscription(mySubscriptionId, {
			isEditing,
			mySubscriptionComponentId,
			subscriptionType
		}).done((data) => {
			var $data = $(data);

			// We're replacing the edit with the view component, or vice versa.
			// So we need to replace the contents of the parent container.
			$currentSubscription.parent().html($data);

			if (isEditing) {
				this.initializeEditComponent(subscriptionType, $data, accountData, submitAction);
			} else {
				this.initializeEditLinks($data);
				this.initializeRenewLinks($data);
			}

			deferred.resolve($data);
		}).fail((jqXHR, textStatus) => {
			this._resolveError(jqXHR, textStatus, deferred);
		});

		return deferred;
	},

	getEditSelector(type) {
		switch (type) {
			case "email": return "[data-component='myMagazineEmailSubscriptions.populated.singleMagazineEmail.edit']";
			case "mail": return "[data-component='myMagazineMailSubscriptions.populated.singleMagazineMail.edit']";
			case "membership": return "[data-component='myMembershipSubscriptions.populated.singleMembership.edit']";
			case "product": return "[data-component='myProductSubscriptions.populated.singleProduct.edit']";
			default: return null;
		}
	},

	getSinglePopulatedSelector(type) {
		switch (type) {
			case "email": return "[data-component='myMagazineEmailSubscriptions.populated.singleMagazineEmail']";
			case "mail": return "[data-component='myMagazineMailSubscriptions.populated.singleMagazineMail']";
			case "membership": return "[data-component='myMembershipSubscriptions.populated.singleMembership']";
			case "product": return "[data-component='myProductSubscriptions.populated.singleProduct']";
			default: return null;
		}
	},

	getSubscriptionSelector(type) {
		switch (type) {
			case "email": return "[data-component='myMagazineEmailSubscriptions']";
			case "mail": return "[data-component='myMagazineMailSubscriptions']";
			case "membership": return "[data-component='myMembershipSubscriptions']";
			case "product": return "[data-component='myProductSubscriptions']";
			default: return null;
		}
	},

	getViewSelector(type) {
		switch (type) {
			case "email": return "[data-component='myMagazineEmailSubscriptions.populated.singleMagazineEmail.view']";
			case "mail": return "[data-component='myMagazineMailSubscriptions.populated.singleMagazineMail.view']";
			case "membership": return "[data-component='myMembershipSubscriptions.populated.singleMembership.view']";
			case "product": return "[data-component='myProductSubscriptions.populated.singleProduct.view']";
			default: return null;
		}
	},

	initializeEditComponent(type, $data, accountData, submitAction) {
		// get data-repeated-id of .edit component
		// using class because each concrete component name is different
		var $editComponent = $data.find(this.getEditSelector(type));
		var $accountForm = $editComponent.find("[data-component='createAccountForm']");
		var $autoRenewCheckboxComponent = $editComponent.find("[data-component='autoRenewCheckbox']");
		var $autoRenewInput = $autoRenewCheckboxComponent.find("input");
		var $editPaymentComponent = $editComponent.find("[data-component='editPaymentCheckbox']");
		var $editPaymentInput = $editPaymentComponent.find("input");
		var $paymentType = $editComponent.find("[data-component='paymentType']");
		var $billingAddressAddForm = $paymentType.find("[data-component='billingAddress.addForm']");
		var $submitButton = $editComponent.find("[data-component='submitButton']");
		var $form = $submitButton.closest("form");

		var mySubscriptionId = $data.attr("data-subscription-id");

		var subscription = JSON.parse($editComponent.attr("data-subscription"));
		var deliveryAccount = subscription.deliveryAccount;

		$form.off("submit.updateSubscription");
		$form.on("submit.updateSubscription", (e) => {
			return submitAction(e);
		});

		// Apply new ids to the new forms being added to the DOM.
		// We use HtmlHelper.getId() here so that we don't apply `id`s to all the forms' nested components.
		var newId = HtmlHelper.getId($("body"));
		var newFormId = HtmlHelper.getId($("body"));
		$accountForm.attr("id", newId);
		$billingAddressAddForm.attr("id", newFormId);

		// append the new create account form `id` to the subscription edit form's `id`.
		// We don't need to reference the billing address form's `id` because its serialization is handled by PaymentHelper.jsx
		var formId = $form.attr("id");
		$form.attr("id", `${formId}_${newId}`);
		$submitButton.attr("form", `${formId}_${newId}`);

		//First and last name should always be disabled
		$accountForm.find("[data-component='accountFirstName'],[data-component='accountLastName']").prop("disabled", true);

		AccountFormHelper.initializeAccountForm(
			$accountForm,
			deliveryAccount
				? Object.assign({}, deliveryAccount, {
					address: subscription.deliveryAddress,
					email: subscription.deliveryEmail
				})
				: Object.assign({}, accountData, {
					address: subscription.deliveryAddress,
					email: subscription.deliveryEmail
				}),
			AccountFormHelper.getParentFormIdFromForm($accountForm)
		);
		//Re-apply listeners
		window.PostalCodeHelper.addCountryChangeListeners($accountForm);
		window.PostalCodeHelper.addCountryChangeListeners($billingAddressAddForm);
		BillingAddressHelper.initialize({
			billingAddressAddFormSelector: $billingAddressAddForm
		});

		SmartyStreets.initializeMySubscriptionsBillingAddressesAdd(mySubscriptionId);
		PaymentHelper.initializePaymentComponent($data);

		// If we don't support auto-renew and we are not already autoRenew, disable checkbox
		//	If the subscription is already auto-renew, we should just work like normal.  They should be able to change their payment, etc.
		//		However, once autoRenew is set to false, it will operate differently.  The constituent will not be able to enable auto Renew again
		if (!subscription.supportsAutoRenew && !subscription.autoRenew) {
			$autoRenewInput
				.prop("checked", false)
				.prop("disabled", true);

			// Hide the payment form by default
			$paymentType.hide();

			// if we're not currently auto-renew, we want to hide the "edit payment" checkbox
			// until they opt into auto-renew.
			// and when we show it, we don't want them to be able to not set up,
			// so it is checked and disabled.
			if (!subscription.autoRenew) {
				$editPaymentComponent.hide();
				$editPaymentInput
					.prop("checked", true)
					.prop("disabled", true);
			}
		} else {
			//Set auto-renew checkbox value.
			$autoRenewInput.prop("checked", subscription.autoRenew);

			// Hide the payment form by default
			$paymentType.hide();

			// if we're not currently auto-renew, we want to hide the "edit payment" checkbox
			// until they opt into auto-renew.
			// and when we show it, we don't want them to be able to not set up,
			// so it is checked and disabled.
			if (!subscription.autoRenew) {
				$editPaymentComponent.hide();
				$editPaymentInput
					.prop("checked", true)
					.prop("disabled", true);
			}

			// add autoRenew check listener, toggle payment form when they check it
			if (subscription.subscriptionStatus === "A" ||
				subscription.subscriptionStatus === "P") {
				$autoRenewCheckboxComponent.off("click.autoRenewToggle");
				$autoRenewCheckboxComponent.on("click.autoRenewToggle", (autoRenewEvent) => {
					var $clickedElement = $(autoRenewEvent.target);
					var $input = $clickedElement.closest("[data-component='autoRenewCheckbox']").find("[data-component='autoRenewCheckbox.input']");
					if ($input.is(":disabled")) {
						return;
					}

					// Toggle the checkbox if the checkbox itself wasn't clicked
					if ($clickedElement.attr("data-component") !== "autoRenewCheckbox.input") {
						$autoRenewInput.prop("checked", !$autoRenewInput.prop("checked"));
					}

					var isAutoRenewChecked = $input.prop("checked");

					//Set all the other autoRenewCheckboxes in this my subscription edit component to the same as the one that was just checked.
					var $allAutoRenewCheckboxesInSubscription = $editComponent.find("input[data-component='autoRenewCheckbox.input']");
					$allAutoRenewCheckboxesInSubscription.prop("checked", isAutoRenewChecked);

					if (isAutoRenewChecked) {
						$editPaymentComponent.show();
						// if we weren't autoRenew but now we are
						// we must add payment
						if (!subscription.autoRenew) {
							$editPaymentInput.prop("checked", true).trigger("change.editPaymentToggle");
							$paymentType.show();
						}
					} else {
						$editPaymentComponent.hide();
						$editPaymentInput.prop("checked", false).trigger("change.editPaymentToggle");
						$paymentType.hide();
					}
				});
				$autoRenewCheckboxComponent.find("*").add($autoRenewCheckboxComponent).css("cursor", "pointer");

				$editPaymentComponent.off("click.editPaymentToggle");
				$editPaymentComponent.on("click.editPaymentToggle", (editPaymentEvent) => {
					var $clickedElement = $(editPaymentEvent.target);
					var $input = $clickedElement.closest("[data-component='editPaymentCheckbox']").find("[data-component='editPaymentCheckbox.input']");
					if ($input.is(":disabled")) {
						return;
					}

					// Toggle the checkbox if the checkbox itself wasn't clicked
					if ($clickedElement.attr("data-component") !== "editPaymentCheckbox.input") {
						$editPaymentInput.prop("checked", !$editPaymentInput.prop("checked"));
					}

					var isEditPaymentChecked = $input.prop("checked");

					//Set all the other editPaymentCheckboxs in this my subscription edit component to the same as the one that was just checked.
					var $allEditPaymentCheckboxesInSubscription = $editComponent.find("input[data-component='editPaymentCheckbox.input']");
					$allEditPaymentCheckboxesInSubscription.prop("checked", isEditPaymentChecked);

					if (isEditPaymentChecked) {
						$paymentType.show();
					} else {
						$paymentType.hide();
					}
				});
				$editPaymentComponent.find("*").add($editPaymentComponent).css("cursor", "pointer");
			} else {
				$editPaymentInput
					.prop("disabled", true);

				$autoRenewInput
					.prop("disabled", true);
			}
		}
	},

	initializeEditLinks($component) {
		//Active or Pending
		var allowedStatusesForVisible = ["A", "P"];
		this.initializeSingleLink($component, allowedStatusesForVisible, "[data-magazine-mail-subscription-view-link='magazineMailSubscriptionEdit']", "[data-component='myMagazineMailSubscriptions.populated.singleMagazineMail']");
		this.initializeSingleLink($component, allowedStatusesForVisible, "[data-magazine-email-subscription-view-link='magazineEmailSubscriptionEdit']", "[data-component='myMagazineEmailSubscriptions.populated.singleMagazineEmail']");
		this.initializeSingleLink($component, allowedStatusesForVisible, "[data-membership-subscription-view-link='membershipSubscriptionEdit']", "[data-component='myMembershipSubscriptions.populated.singleMembership']");
	},

	initializeRenewLinks($component) {
		//Expired or Canceled
		var allowedStatusesForVisible = ["E", "X"];
		this.initializeSingleLink($component, allowedStatusesForVisible, "[data-magazine-mail-subscription-view-link='magazineMailSubscriptionRenew']", "[data-component='myMagazineMailSubscriptions.populated.singleMagazineMail']");
		this.initializeSingleLink($component, allowedStatusesForVisible, "[data-magazine-email-subscription-view-link='magazineEmailSubscriptionRenew']", "[data-component='myMagazineEmailSubscriptions.populated.singleMagazineEmail']");
		this.initializeSingleLink($component, allowedStatusesForVisible, "[data-membership-subscription-view-link='membershipSubscriptionRenew']", "[data-component='myMembershipSubscriptions.populated.singleMembership']");
	},

	initializeSingleLink($component, allowedStatusesForVisible, linkSelector, singleSubscriptionSelector) {
		$($component || "body").find(linkSelector).each((index, link) => {
			var $link = $(link);
			var status = $link.closest(singleSubscriptionSelector).attr("data-subscription-status");
			if (status && allowedStatusesForVisible.includes(status)) {
				$link.show();
			}
		});
	},

	_resolveError(jqXHR, textStatus, deferred) {
		if (!jqXHR || !jqXHR.responseJSON || !PartialResponseHelper.handleErrorResponse(jqXHR.responseJSON)) {
			//There was not a partial error, so do what we normally would do.
			ApiHelper.displayErrorMessage(jqXHR);
		}

		if (deferred) {
			deferred.reject(jqXHR, textStatus);
		}
	}
};

module.exports = MySubscriptionsRefresh;
